export default "__VITE_ASSET__Cp7xVbvg__"